__webpack_require__.p = "https://rk.geosamara.ru/product/universal_map_widget/";